import React, { Component } from 'react'
import axios from 'axios'
import './_css/login.css'
import LogoPSMD from './_img/PSMD1.png'
import LogoPSMT from './_img/PSMT.png'
import LogoPSAL from './_img/PSAL.png'
import LogoPSMP from './_img/PSMP.jpg'
import { CSLogin } from './_config.js'
import { Button } from 'react-bootstrap'
import Snackbar from './Components/Snackbar/Snackbar'
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
var urlPast = window.location.hostname;
export default class Login extends Component {
    state = {
        ServiceLogin: '',
        name: '',
        pass: '',
        text: '',
        persons: [],
        company: 'PSMD',
        BgColor: 'PSMDClass',
        acKry: "0",
        PSname: ['มดแดงมอเตอร์', 'พรประเสริฐมอเตอร์', 'พรประเสริฐออโตลิส', 'โมโตพาร์ท'],
        logo: [LogoPSMD, LogoPSMT, LogoPSAL, LogoPSMP],
        SDcolor: ['divLogo shadowColor0', 'divLogo shadowColor1', 'divLogo shadowColor2', 'divLogo shadowColor2'],
        bgImg: ['imgbg0', 'imgbg1', 'imgbg2', 'imgbg3'],
    }
    UsernameChange = (event) => { this.setState({ name: event.target.value }) }
    PasswordleChange = (event) => { this.setState({ pass: event.target.value }) }
    componentDidMount = () => {
        // localStorage.setItem("hostname", urlPast)
        // document.getElementById('_window').style.width = window.innerWidth+"px" 
        console.log("computerName", GetComputerName())
        switch (urlPast) {
            case 'psmd.pspl.co.th':
                this.setState({ acKry: "0" })
                localStorage.setItem("company", "PSMD")
                this.setState({ ServiceLogin: CSLogin("PSMD") })
                break
            case 'psmt.pspl.co.th':
                this.setState({ acKry: "1" })
                localStorage.setItem("company", "PSMT")
                this.setState({ ServiceLogin: CSLogin("PSMT") })
                break
            case 'psal.pspl.co.th':
                this.setState({ acKry: "2" })
                localStorage.setItem("company", "PSAL")
                this.setState({ ServiceLogin: CSLogin("PSAL") })
                break
            case 'psmp.pspl.co.th':
                this.setState({ acKry: "3" })
                localStorage.setItem("company", "PSMP")
                this.setState({ ServiceLogin: CSLogin("PSMP") })
                break
            default:
                urlPast = process.env.REACT_APP_MAINURL
                this.componentDidMount()
                break
        }
    }
    handleSubmit = async () => {
        // console.log("Password", this.refs.Password.value);
        var username = this.state.name
        var password = this.state.pass

        if (typeof username === "undefined") {
            this.setState({ respost: "กรุณากรอก Username" })
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorRoundedIcon })
            return
        }

        if (username === "") {
            this.setState({ respost: "กรุณากรอก Username" })
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorRoundedIcon })
            return
        }
        if (typeof password === "undefined") {
            this.setState({ respost: "กรุณากรอก password" })
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorRoundedIcon })
            return
        }

        if (password === "") {
            this.setState({ respost: "กรุณากรอก password" })
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorRoundedIcon })
            return
        }

        const para = new URLSearchParams()
        para.append("user", username)
        para.append("pass", password)
        // para.append("expi", 100)
        para.append("expi", 14403)
        let status = ""
        await axios.post(this.state.ServiceLogin, para).then(res => {
            //  console.log("respost", localStorage.getItem("Ipadds"))
            //  return
            try {
                if (typeof res.data.jwt !== "undefined") {
                    status = res.data.status
                    localStorage.setItem("Token", res.data.jwt)
                } else {
                    status = res.data.status
                    this.setState({ respost: res.data })
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorRoundedIcon })
                }
            } catch (error) {
            }
        },
            error => {
                this.setState({ respost: "Error! not connect Service" })
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorRoundedIcon })

                this.setState({ text: " Error! not connect Service " })
            }
        )
        await localStorage.setItem("Username", username)
        if (status === "SUCCESS") {
            window.location.href = '/home'
        }
    }
    onKeyPress = (e) => {
        if (e.charCode === 13) {
            this.handleSubmit()
        }
    }
    render() {
        return (<>
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="sm">
                    <div className="panel-body ACLogin" align="center">
                        <h1> Welcome to PSAccount </h1>

                        <div className="divLogin" align="center">
                            <form className="form-1" >
                                <div className={this.state.SDcolor[this.state.acKry]}>
                                    <img src={this.state.logo[this.state.acKry]} alt={this.state.logo[this.state.acKry]} className={this.state.bgImg[this.state.acKry]} />
                                </div>
                                <h2><span> {this.state.PSname[this.state.acKry]}</span></h2>
                                <p className="field">
                                    <input type="text" name="Username" placeholder="Username" onChange={this.UsernameChange} ref="Username" />
                                    <i className="fas fa-user"></i>
                                </p>
                                <p className="field">
                                    <input type="password" name="Password" placeholder="Password" onChange={this.PasswordleChange} ref="Password" onKeyPress={this.onKeyPress} />
                                    <i className="fas fa-unlock-alt"></i>
                                </p>
                                {/* <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>  เข้าสู่ระบบ </button> */}
                                <Button bsStyle="primary" bsSize="small" onClick={e => this.handleSubmit()}>เข้าสู่ระบบ</Button>
                                {/* <p>
                        </p> */}
                            </form>
                        </div>
                        {/* <p > {this.state.respost}</p> */}
                        <div>
                            {/* <Buttonm variant="text" onClick={() => clearCacheData()}>Clear Cache Data</Buttonm> */}
                        </div>
                    </div>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={36000}
                        message={this.state.respost}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </Container>
            </React.Fragment>

        </>

        )
    }
}


function GetComputerName() {

    // var network = new ActiveXObject('WScript.Network');

    return ""

}